/* Delegated actions also work after Horizon replaces filter results or loads another page. */
(() => {
  const root = document.querySelector('.kh-catalog, .kh-product-page #MainContent');
  if (!root) return;
  const base = window.Shopify?.routes?.root || '/';
  function paintNames() {
    let name = '';
    try { name = (localStorage.getItem('kh-name') || '').trim().slice(0,24); } catch {}
    root.querySelectorAll('[data-kh-catalog-name]').forEach(el => {
      el.textContent = name ? `${name} için` : '';
      el.hidden = !name;
    });
  }
  paintNames();
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-kh-catalog-name]') || n.querySelector('[data-kh-catalog-name]'))))) paintNames();
  }).observe(root,{childList:true,subtree:true});
  root.addEventListener('click', async event => {
    const button = event.target.closest('[data-kh-catalog-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const status = button.closest('.kh-card').querySelector('[data-kh-catalog-status]');
    button.disabled = true;
    button.textContent = 'Ekleniyor';
    status.textContent = '';
    try {
      const res = await fetch(`${base}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.khCatalogAdd),quantity:1}]})});
      const result = await res.json();
      if (!res.ok) throw new Error(result.description || 'Ürün eklenemedi. Lütfen tekrar deneyin.');
      const cart = await (await fetch(`${base}cart.js`)).json();
      document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'kh-catalog',data:{itemCount:cart.item_count,source:'kh-catalog',variantId:button.dataset.khCatalogAdd}}}));
      button.textContent = 'Sepete eklendi';
      status.textContent = 'Ürün sepetinize eklendi.';
    } catch (error) {
      button.textContent = 'Tekrar dene';
      status.textContent = error.message;
    } finally {
      setTimeout(()=>{button.disabled=false;button.textContent='Sepete ekle';},2200);
    }
  });
})();
